import { useEffect, useState } from "react";
import { ReceiverBackdrop, ReceiverHeader } from "./components/world/ReceiverPrimitives";
import "./receiver-world.css";

const DEMO_INTRODUCER = "John";
const DEMO_RECIPIENT = "Mike";
const DEMO_THEME = "warm";

export default function RecipientLanding({
  introducerName = DEMO_INTRODUCER,
  recipientName = DEMO_RECIPIENT,
  theme = DEMO_THEME,
  onBegin = () => {},
  onVoiceBegin = null,
}) {
  const [step, setStep] = useState(0);
  const isClean = theme === "clean" || theme === "Clean & simple" || theme === "Straightforward & low-key";

  useEffect(() => {
    const reducedMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
    if (reducedMotion) {
      setStep(4);
      return undefined;
    }

    const timers = [
      setTimeout(() => setStep(1), 400),
      setTimeout(() => setStep(2), 2500),
      setTimeout(() => setStep(3), 4200),
      setTimeout(() => setStep(4), 5800),
    ];
    return () => timers.forEach(clearTimeout);
  }, []);

  return (
    <main className="tgc-receiver-shell tgc-receiver-shell--arrival" aria-labelledby="receiver-arrival-heading">
      <ReceiverBackdrop />
      <ReceiverHeader eyebrow="A gift for you" />

      <div className="tgc-receiver-main">
        <section className="tgc-receiver-arrival">
          {step >= 1 && (
            <div className="tgc-receiver-arrival__greeting tgc-receiver-reveal">
              <h1 id="receiver-arrival-heading">{isClean ? `${recipientName}.` : `Hey ${recipientName}.`}</h1>
              <p>{isClean ? `${introducerName} set this up for you.` : `${introducerName} set something up for you.`}</p>
            </div>
          )}

          {step >= 2 && (
            <p className="tgc-receiver-disclosure tgc-receiver-reveal">
              {isClean
                ? `You're about to talk to an AI. ${introducerName} filled out a profile about you beforehand — so it already knows a few things. That's intentional.`
                : `You're about to have a conversation with an AI — and yes, it already knows a few things about you. That's because ${introducerName} filled out a short profile before you got here. So when it feels familiar, that's why.`}
            </p>
          )}

          {step >= 3 && (
            <p className="tgc-receiver-reassurance tgc-receiver-reveal">
              {isClean
                ? `No agenda. No pitch. No right answers. Say whatever's on your mind. Come back when you're ready.`
                : `This conversation is just for you. No agenda, no pitch, no right answers. Put the phone down if you need to. Come back when you're ready. This is your time.`}
            </p>
          )}

          {step >= 4 && (
            <div className="tgc-receiver-reveal">
              <div className="tgc-receiver-mode-grid" aria-label="Choose text or voice conversation">
                {onVoiceBegin && (
                  <button className="tgc-receiver-mode" type="button" onClick={onVoiceBegin}>
                    Start Voice Conversation
                  </button>
                )}
                <button className="tgc-receiver-mode" type="button" onClick={onBegin}>
                  {onVoiceBegin
                    ? "Start Text Conversation"
                    : (isClean ? "START →" : "Begin →")}
                </button>
              </div>
              <p className="tgc-receiver-closing">
                {isClean
                  ? `${introducerName} set this up hoping you get something out of it. Enjoy your conversation.`
                  : `${introducerName} set this up as a gift. Enjoy your conversation.`}
              </p>
            </div>
          )}
        </section>
      </div>
    </main>
  );
}
